<template>
  <div>
    <el-dialog
      v-model="dialogVisible"
      width="600px"
      @close="handleClose"
      destroy-on-close
      class="handover-dialog-container"
    >
      <template #header>
        <div flex items-center text-size-20px>
          <span>交接班</span>
        </div>
      </template>
      <div class="handover-content" flex>
        <el-form class="handover-form" :rules="rules" :model="form" ref="formRef" label-width="110px">
          <div m-10px fw-600 color="#000000e6">本班信息</div>
          <el-form-item label="开班员工：">
            <span>{{ currentShift?.merchantUser?.name }}</span>
          </el-form-item>
          <el-form-item label="现金收款：">
            <span>{{ ((currentShift?.totalIncome || 0) / 100).toFixed(2) }}元</span>
          </el-form-item>
          <el-form-item label="预备金：">
            <el-input-number
              :controls="false"
              :precision="2"
              :step="0.01"
              :min="0"
              v-model="form.amount"
              placeholder="请输入预备金"
              @blur="handleBlur"
            />
            <span ml-8px>元</span>
          </el-form-item>
          <div m-10px fw-600 color="#000000e6">交接班</div>
          <el-form-item label="上缴现金：" prop="handInAmount">
            <el-input-number
              :controls="false"
              :precision="2"
              :step="0.01"
              :min="0"
              v-model="form.handInAmount"
              placeholder="请输入上缴现金"
              @blur="handleBlur"
            />
            <span ml-8px>元</span>
          </el-form-item>
          <el-form-item label="备注：">
            <el-input v-model="form.notes" :rows="2" type="textarea" placeholder="请输入备注信息" />
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <el-button type="primary" color="#0052D9" @click="handleHandover">交班并退出</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script lang="ts" setup>
import type { FormInstance } from "element-plus"
import type { HandoverDetailType } from "@/api/user/types/worker"
import { ElMessage } from "element-plus"
import { ref, watch } from "vue"
import { useRouter } from "vue-router"
import { getCurrentShift, handover } from "@/api/user/worker"
import { applyShiftOpenResult } from "@/store/modules/shiftStatus"
import { useUserStore } from "@/store/modules/user"
import { convertYuanInputToCents } from "@/utils/math"

const router = useRouter()

const emit = defineEmits(["update:show", "refresh"])

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
})

const dialogVisible = ref(false)
const userStore = useUserStore()
const currentShift = ref<HandoverDetailType>()
const rules = {
  handInAmount: [{ required: true, message: "请输入上缴现金", trigger: "blur" }],
}
const formRef = ref<FormInstance>()
const form = ref({
  amount: 0,
  handInAmount: 0,
  notes: "",
})

watch(
  () => props.show,
  (val) => {
    dialogVisible.value = val
  },
  {
    immediate: true,
  },
)

const handleClose = () => {
  dialogVisible.value = false
  emit("update:show", false)
}

const handleBlur = () => {
  if (form.value.amount < 0 || !form.value.amount) {
    form.value.amount = 0
  }
}

const handleHandover = () => {
  formRef.value?.validate((valid) => {
    if (valid) {
      const targetShopId = Number(userStore.shopId)
      handover({
        ...currentShift.value,
        retainedCash: convertYuanInputToCents(form.value.amount),
        handInCash: convertYuanInputToCents(form.value.handInAmount),
        notes: form.value.notes,
      }).then(() => {
        applyShiftOpenResult({
          targetShopId,
          currentShopId: Number(userStore.shopId),
          isOpen: false,
          snapshot: userStore.shiftStatusSnapshot,
          setOpen: (isOpen, shopId) => userStore.setOpen(isOpen, shopId),
          resetShiftStatus: () => userStore.resetShiftStatus(),
        })
        emit("update:show", false)
        dialogVisible.value = false
        emit("refresh")
        ElMessage({
          message: "交班成功",
          type: "success",
        })
        userStore.logout()
        router.push("/login")
      })
    }
  })
}

const getCurrentShiftInfo = () => {
  getCurrentShift().then((res) => {
    if (res.data) {
      currentShift.value = res.data
      form.value.amount = (res.data.retainedCash || 0) / 100
    }
  })
}

getCurrentShiftInfo()
</script>

<style scoped lang="scss">
.handover-content {
  .handover-form {
    width: 100%;
  }
}
</style>
